import React, { useState, useEffect } from 'react';
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import Login from './Login';
import LandingPage from './LandingPage';
import OptionChain from './OptionChain';
import StrategyBacktester from './StrategyBacktester';
import AdvancedAnalytics from './AdvancedAnalytics';
import RiskGuardian from './RiskGuardian';
import OptionsGreeks from './OptionsGreeks';
import StrategyBuilder from './StrategyBuilder';
import AlgoTradingBot from './AlgoTradingBot';
import WelcomeModal from './WelcomeModal';
import PerformanceReportModal from './PerformanceReportModal';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('landing'); 
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('vyodha_theme');
    return savedTheme !== null ? JSON.parse(savedTheme) : true;
  });

  const [orderType, setOrderType] = useState(null); 
  const [activeTab, setActiveTab] = useState('chart');
  const [selectedOption, setSelectedOption] = useState(null);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isWelcomeOpen, setIsWelcomeOpen] = useState(true);

  const [selectedTimeframe, setSelectedTimeframe] = useState('1D');
  const timeframes = ['1S', '1M', '3M', '5M', '15M', '1H', '4H', '1D'];

  const [positions, setPositions] = useState([]);
  const [totalPnL, setTotalPnL] = useState(0);
  const [marketMode, setMarketMode] = useState('INDIAN');
  const [virtualWallet, setVirtualWallet] = useState(1000000);
  const [depositAmount, setDepositAmount] = useState('');

  const [currentUser, setCurrentUser] = useState(() => {
    return JSON.parse(localStorage.getItem('vyodha_current_user')) || {
      name: 'Trader',
      myReferralCode: 'VYODHA-7788',
      points: 150,
      hasDiscount: false,
      trialEndDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString()
    };
  });

  const [selectedBroker, setSelectedBroker] = useState(() => localStorage.getItem('vyodha_broker') || 'Zerodha Kite');
  const [apiKeyInput, setApiKeyInput] = useState(() => localStorage.getItem('vyodha_api_key') || '');
  const [apiSecretInput, setApiSecretInput] = useState('');
  const [isApiConnected, setIsApiConnected] = useState(() => !!localStorage.getItem('vyodha_api_key'));

  const [sectorHeatmapData, setSectorHeatmapData] = useState([
    { sector: "Banking", symbol: "HDFC / ICICI", change: "+1.45%", isUp: true, weight: "Heavy" },
    { sector: "IT Services", symbol: "TCS / INFOSYS", change: "+2.10%", isUp: true, weight: "Heavy" },
    { sector: "Automobile", symbol: "MARUTI / TATA", change: "-0.85%", isUp: false, weight: "Medium" },
    { sector: "Energy & Oil", symbol: "RELIANCE / ONGC", change: "+0.40%", isUp: true, weight: "Heavy" },
    { sector: "Pharma", symbol: "SUNPHARMA / DRREDDY", change: "-1.20%", isUp: false, weight: "Medium" },
    { sector: "FMCG", symbol: "ITC / HUL", change: "+0.15%", isUp: true, weight: "Medium" },
    { sector: "Metals", symbol: "TATASTEEL / HINDALCO", change: "-2.40%", isUp: false, weight: "Low" },
    { sector: "Media", symbol: "ZEE / PVR", change: "+0.90%", isUp: true, weight: "Low" }
  ]);

  const [isTrailBotActive, setIsTrailBotActive] = useState(false);
  const [trailBuffer, setTrailBuffer] = useState(25);
  const [botLogs, setBotLogs] = useState([
    { id: 1, text: "Vyodha Trailing Bot initialized and standing by for active positions.", time: "10:00 AM" }
  ]);

  const [basketName, setBasketName] = useState('Nifty Bull Spread Strategy');
  const [basketItems, setBasketItems] = useState([
    { id: 1, symbol: 'NIFTY 24300 CE', action: 'BUY', qty: 50, price: 355.50 },
    { id: 2, symbol: 'NIFTY 24500 CE', action: 'SELL', qty: 50, price: 165.00 }
  ]);
  const [basketSymbolInput, setBasketSymbolInput] = useState('NIFTY 24400 CE');
  const [basketActionInput, setBasketActionInput] = useState('BUY');
  const [basketQtyInput, setBasketQtyInput] = useState(50);
  const [basketPriceInput, setBasketPriceInput] = useState(265.40);

  const [chatRoomMessages, setChatRoomMessages] = useState([
    { id: 1, sender: "Vikram Trader", badge: "💎 Elite Master", text: "Nifty 24350 CE call breaking resistance with heavy volume! 🚀", time: "10:15 AM" },
    { id: 2, sender: "Aarav Sharma", badge: "🔥 Pro Scalper", text: "Bitcoin testing $68,500 support zone. Watch closely.", time: "10:18 AM" },
    { id: 3, sender: "Priya Singh", badge: "🎯 Disciplined", text: "Main aaj sirf 1 trade lungi disciplined tarike se. No overtrading.", time: "10:22 AM" }
  ]);
  const [socialMessageInput, setSocialMessageInput] = useState('');

  const [calcCapital, setCalcCapital] = useState(100000);
  const [calcRiskPercent, setCalcRiskPercent] = useState(1);
  const [calcEntryPrice, setCalcEntryPrice] = useState(80500);
  const [calcStopLoss, setCalcStopLoss] = useState(80200);
  const [calcResult, setCalcResult] = useState(null);

  const [chatMessages, setChatMessages] = useState([
    { sender: 'ai', text: "Hello trader! Main Vyodha AI Assistant hoon. Powered by your live Gemini API key. Aap mujhse koi bhi market sawal, options strategy, ya Greeks ke baare mein pooch sakte hain." }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const [uploadedImagePreview, setUploadedImagePreview] = useState(null);
  const [isAiTyping, setIsAiTyping] = useState(false);

  const [marketIndices, setMarketIndices] = useState([
    { symbol: "SENSEX", price: 80500.00, change: "+360.50", percent: "+0.45%", isUp: true },
    { symbol: "NIFTY 50", price: 24350.25, change: "+158.10", percent: "+0.65%", isUp: true },
    { symbol: "BANKNIFTY", price: 52100.50, change: "-104.20", percent: "-0.20%", isUp: false },
    { symbol: "FINNIFTY", price: 23420.00, change: "+85.40", percent: "+0.37%", isUp: true },
  ]);

  const cryptoIndices = [
    { symbol: "BTC/USDT", price: 68450.00, change: "+1250.00", percent: "+1.86%", isUp: true },
    { symbol: "ETH/USDT", price: 3520.50, change: "+95.20", percent: "+2.78%", isUp: true },
    { symbol: "SOL/USDT", price: 185.40, change: "-4.20", percent: "-2.21%", isUp: false },
    { symbol: "BNB/USDT", price: 590.10, change: "+12.50", percent: "+2.16%", isUp: true },
  ];

  const indianWatchList = [
    { symbol: "SENSEX", price: "80,500.00", change: "+0.45%", isUp: true },
    { symbol: "NIFTY", price: "24,350.25", change: "+0.65%", isUp: true },
    { symbol: "BANKNIFTY", price: "52,100.50", change: "-0.20%", isUp: false },
    { symbol: "RELIANCE", price: "3,120.25", change: "+1.15%", isUp: true },
  ];

  const cryptoWatchList = [
    { symbol: "BTC/USDT", price: "68,450.00", change: "+1.86%", isUp: true },
    { symbol: "ETH/USDT", price: "3,520.50", change: "+2.78%", isUp: true },
    { symbol: "SOL/USDT", price: "185.40", change: "-2.21%", isUp: false },
    { symbol: "XRP/USDT", price: "0.62", change: "+0.85%", isUp: true },
  ];

  const marketNews = [
    { id: 1, text: "RBI maintains repo rate at 6.5%, banking sector volatile.", sentiment: "BULLISH 🟢" },
    { id: 2, text: "Bitcoin crosses key resistance, institutional inflows surge.", sentiment: "BULLISH 🟢" },
    { id: 3, text: "Global crude oil prices dip 2%, auto stocks likely to rally.", sentiment: "BULLISH 🟢" },
    { id: 4, text: "US Fed hints at possible rate trajectory adjustments, tech stocks cautious.", sentiment: "BEARISH 🔴" }
  ];

  const [journalEntries, setJournalEntries] = useState([
    { id: 1, symbol: "NIFTY 24350 CE", emotion: "FOMO", note: "Entered too early without waiting for candle close.", aiFeedback: "⚠️ High Risk: Avoid chasing momentum breakouts.", date: "05 Aug 2026" }
  ]);
  const [journalNote, setJournalNote] = useState('');
  const [selectedEmotion, setSelectedEmotion] = useState('Calm & Planned');

  const [holdings, setHoldings] = useState([
    { id: 1, symbol: "RELIANCE", qty: 10, avgPrice: 3100.00, ltp: 3120.25, pnl: 202.50 },
    { id: 2, symbol: "TCS", qty: 5, avgPrice: 4150.00, ltp: 4180.00, pnl: 150.00 },
    { id: 3, symbol: "BTC (Crypto)", qty: 0.1, avgPrice: 65000.00, ltp: 68450.00, pnl: 345.00 }
  ]);

  const [alerts, setAlerts] = useState([
    { id: 1, symbol: "SENSEX", targetPrice: 81000, condition: "ABOVE", active: true },
    { id: 2, symbol: "BTC/USDT", targetPrice: 70000, condition: "ABOVE", active: true }
  ]);
  const [alertSymbol, setAlertSymbol] = useState('SENSEX');
  const [alertPrice, setAlertPrice] = useState('');
  const [alertCondition, setAlertCondition] = useState('ABOVE');
  const [triggeredAlert, setTriggeredAlert] = useState(null);

  const [ledgerHistory, setLedgerHistory] = useState([
    { id: 1, type: 'DEPOSIT', amount: 1000000, desc: 'Initial Signup Bonus Capital', date: '05 Aug 2026' }
  ]);

  const [stopLossPrice, setStopLossPrice] = useState('');
  const [targetPrice, setTargetPrice] = useState('');

  const [disciplineScore, setDisciplineScore] = useState(100);
  const [tradeCount, setTradeCount] = useState(0);
  const [aiMessage, setAiMessage] = useState("Perfect setup. Stick to your trading plan and stay calm.");

  const [leaderboardData, setLeaderboardData] = useState([
    { rank: 1, name: "Vikram Trader", score: 98, pnl: 145200, badge: "💎 Elite Master" },
    { rank: 2, name: "Aarav Sharma", score: 94, pnl: 98400, badge: "🔥 Pro Scalper" },
    { rank: 3, name: "Priya Singh", score: 91, pnl: 76200, badge: "🎯 Disciplined" },
    { rank: 4, name: "Rahul Verma", score: 85, pnl: 45000, badge: "📈 Swing Trader" },
    { rank: 5, name: "Aap (You)", score: 100, pnl: 0, badge: "🚀 Rookie" },
  ]);

  const playAlertSound = () => {
    try {
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const playCoinTone = (time) => {
        const osc = audioCtx.createOscillator();
        const gain = audioCtx.createGain();
        osc.type = 'square';
        osc.frequency.setValueAtTime(1000, time);
        osc.frequency.exponentialRampToValueAtTime(500, time + 0.1);
        gain.gain.setValueAtTime(0.2, time);
        gain.gain.exponentialRampToValueAtTime(0.01, time + 0.15);
        osc.connect(gain);
        gain.connect(audioCtx.destination);
        osc.start(time);
        osc.stop(time + 0.15);
      };
      playCoinTone(audioCtx.currentTime);
      playCoinTone(audioCtx.currentTime + 0.25);
    } catch (e) {
      console.log("Audio not supported");
    }
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem('vyodha_theme', JSON.stringify(newTheme));
  };
  
  const openOrderWindow = (type, optionDetails = null) => {
    setSelectedOption(optionDetails);
    setOrderType(type);
    const basePrice = optionDetails ? optionDetails.price : (marketMode === 'INDIAN' ? 80500 : 68450);
    setStopLossPrice(type === 'BUY' ? (basePrice - 50).toFixed(2) : (basePrice + 50).toFixed(2));
    setTargetPrice(type === 'BUY' ? (basePrice + 100).toFixed(2) : (basePrice - 100).toFixed(2));
  };

  const closeOrderWindow = () => {
    setOrderType(null);
    setSelectedOption(null);
  };

  const handleAddFunds = (e) => {
    e.preventDefault();
    const amt = parseFloat(depositAmount);
    if (!amt || amt <= 0) return;
    const depositValue = marketMode === 'INDIAN' ? amt : amt * 84;
    setVirtualWallet(prev => prev + depositValue);
    setLedgerHistory([
      { id: Date.now(), type: 'DEPOSIT', amount: depositValue, desc: `Added ${marketMode === 'INDIAN' ? '₹' : '$'} ${amt} via Wallet`, date: new Date().toLocaleDateString() },
      ...ledgerHistory
    ]);
    setDepositAmount('');
    alert(`Successfully added ${marketMode === 'INDIAN' ? '₹' : '$'} ${amt} to your Vyodha Virtual Wallet!`);
  };

  const handleConnectApi = (e) => {
    e.preventDefault();
    if (!apiKeyInput.trim() || !apiSecretInput.trim()) {
      alert("Please enter valid API Key and Secret Key.");
      return;
    }
    setIsApiConnected(true);
    localStorage.setItem('vyodha_broker', selectedBroker);
    localStorage.setItem('vyodha_api_key', apiKeyInput);
    alert(`Successfully connected to ${selectedBroker} Live API! Credentials securely saved.`);
  };

  const handleAddJournal = (e) => {
    e.preventDefault();
    if (!journalNote.trim()) return;
    let feedback = "✅ Great discipline! Your trade setup matched institutional rules.";
    if (selectedEmotion === 'FOMO (Fear of Missing Out)') feedback = "⚠️ Warning: FOMO trading increases drawdown risk by 60%. Wait for pullbacks.";
    if (selectedEmotion === 'Revenge Trading') feedback = "🚨 Critical Alert: Trying to recover losses quickly leads to account wipeout. Take a 1-hour break!";

    const newEntry = {
      id: Date.now(),
      symbol: selectedOption ? `${selectedOption.strike} ${selectedOption.type}` : (marketMode === 'INDIAN' ? "BSE:SENSEX" : "BINANCE:BTCUSDT"),
      emotion: selectedEmotion,
      note: journalNote,
      aiFeedback: feedback,
      date: new Date().toLocaleDateString()
    };
    setJournalEntries([newEntry, ...journalEntries]);
    setJournalNote('');
    alert("Trade journal entry recorded and analyzed by Vyodha AI!");
  };

  const handleAddAlert = (e) => {
    e.preventDefault();
    const priceVal = parseFloat(alertPrice);
    if (!priceVal || priceVal <= 0) return;
    const newAlert = { id: Date.now(), symbol: alertSymbol, targetPrice: priceVal, condition: alertCondition, active: true };
    setAlerts([newAlert, ...alerts]);
    setAlertPrice('');
    alert(`Price alert successfully set for ${alertSymbol} at ₹ ${priceVal}!`);
  };

  const handleAddBasketLeg = (e) => {
    e.preventDefault();
    const newLeg = { id: Date.now(), symbol: basketSymbolInput, action: basketActionInput, qty: parseInt(basketQtyInput) || 50, price: parseFloat(basketPriceInput) || 100 };
    setBasketItems([...basketItems, newLeg]);
    alert(`Added ${newLeg.action} ${newLeg.qty}x ${newLeg.symbol} to basket!`);
  };

  const executeBasketOrder = () => {
    if (basketItems.length === 0) {
      alert("Basket is empty!");
      return;
    }
    
    let totalBasketMargin = 0;
    basketItems.forEach(item => {
      totalBasketMargin += (item.price * item.qty) * 0.20;
    });

    if (virtualWallet < totalBasketMargin && !isApiConnected) {
      alert("⚠️ Insufficient Margin for Basket Order!");
      return;
    }

    setVirtualWallet(prev => prev - totalBasketMargin);

    const newPositionsToAdd = basketItems.map(item => ({
      id: Date.now() + Math.random(),
      symbol: item.symbol,
      type: item.action,
      qty: item.qty,
      avgPrice: item.price,
      ltp: item.price,
      marginBlocked: (item.price * item.qty) * 0.20,
      sl: +(item.price * 0.95).toFixed(2),
      target: +(item.price * 1.10).toFixed(2),
      pnl: 0
    }));

    setPositions(prev => [...prev, ...newPositionsToAdd]);
    setTradeCount(prev => prev + basketItems.length);
    alert(`🚀 Successfully executed Basket "${basketName}" containing ${basketItems.length} legs instantly!`);
  };

  const calculateRiskPosition = (e) => {
    e.preventDefault();
    const cap = parseFloat(calcCapital);
    const riskPct = parseFloat(calcRiskPercent);
    const entry = parseFloat(calcEntryPrice);
    const sl = parseFloat(calcStopLoss);
    if (!cap || !riskPct || !entry || !sl || entry === sl) {
      alert("Please enter valid numbers and ensure Entry Price is not equal to Stop-Loss.");
      return;
    }
    const maxRiskAmount = (cap * riskPct) / 100;
    const riskPerUnit = Math.abs(entry - sl);
    const recommendedQty = Math.floor(maxRiskAmount / riskPerUnit);
    const target1 = entry + (riskPerUnit * 2);
    setCalcResult({
      maxRiskAmount: maxRiskAmount.toFixed(2),
      riskPerUnit: riskPerUnit.toFixed(2),
      recommendedQty: recommendedQty > 0 ? recommendedQty : 1,
      target1: target1.toFixed(2),
      aiVerdict: recommendedQty > 0 ? "✅ Safe Position Size calculated according to institutional risk management rules." : "⚠️ Warning: Stop-loss too tight or risk capital too low."
    });
  };

  const handleSendSocialMessage = (e) => {
    e.preventDefault();
    if (!socialMessageInput.trim()) return;
    const newMsg = {
      id: Date.now(),
      sender: "Aap (You)",
      badge: "🚀 Rookie",
      text: socialMessageInput,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
    setChatRoomMessages(prev => [...prev, newMsg]);
    setSocialMessageInput('');
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim() && !uploadedImagePreview) return;
    const userText = inputMessage;
    const userImage = uploadedImagePreview;
    const newMsg = { sender: 'user', text: userText || "[Chart Screenshot Uploaded]", image: userImage };
    setChatMessages(prev => [...prev, newMsg]);
    setInputMessage('');
    setUploadedImagePreview(null);
    setIsAiTyping(true);

    try {
      const geminiApiKey = "AQ.Ab8RN6IEC2XaulWd_NisBc74X0Wi0QMB3b-hnSZ_woCW-GIwsQ";
      const response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-3.6-flash:generateContent?key=${geminiApiKey}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contents: [{
            parts: [{
              text: `You are Vyodha AI, an elite institutional options trading coach and expert risk manager. Give precise, practical, and professional advice for this query: ${userText || "Analyze this market query"}`
            }]
          }]
        })
      });
      const data = await response.json();
      if (data.error) throw new Error(data.error.message || "API error occurred");
      const aiReplyText = data.candidates?.[0]?.content?.parts?.[0]?.text || "Market conditions are stable. Adhere to your risk parameters.";
      setChatMessages(prev => [...prev, { sender: 'ai', text: aiReplyText }]);
    } catch (error) {
      setChatMessages(prev => [...prev, { sender: 'ai', text: `⚠️ Gemini Error: ${error.message}. Please check network or API limits.` }]);
    } finally {
      setIsAiTyping(false);
    }
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) setUploadedImagePreview(URL.createObjectURL(file));
  };

  // MARGIN BLOCK & ORDER EXECUTION
  const executeOrder = () => {
    const tradeSymbol = selectedOption ? `${selectedOption.strike} ${selectedOption.type}` : (marketMode === 'INDIAN' ? "BSE:SENSEX" : "BINANCE:BTCUSDT");
    const tradePrice = selectedOption ? selectedOption.price : (marketMode === 'INDIAN' ? 80500.00 : 68450.00);
    const orderQty = marketMode === 'INDIAN' ? 50 : 1;
    const requiredMargin = (tradePrice * orderQty) * 0.20; // 20% Margin block

    if (virtualWallet < requiredMargin && !isApiConnected) {
      alert("⚠️ Insufficient Virtual Margin! Required: ₹ " + requiredMargin.toFixed(2));
      return;
    }

    setVirtualWallet(prev => prev - requiredMargin); // Deduct Margin

    const newTradeCount = tradeCount + 1;
    setTradeCount(newTradeCount);

    if (newTradeCount > 3) {
      setDisciplineScore(prev => Math.max(0, prev - 15));
      setAiMessage("⚠️ OVERTRADING DETECTED! Take a break.");
    } else if (totalPnL < -2000) {
      setDisciplineScore(prev => Math.max(0, prev - 25));
      setAiMessage("🚨 REVENGE TRADING ALERT! Do not chase losses!");
    } else {
      setAiMessage(isApiConnected ? `Order routed live via ${selectedBroker} API!` : "Paper trade successfully placed and locked in order book.");
    }

    const newPosition = {
      id: Date.now(),
      symbol: tradeSymbol,
      type: selectedOption ? (selectedOption.type === 'CE' ? 'BUY' : 'SELL') : orderType,
      qty: orderQty,
      avgPrice: tradePrice,
      ltp: tradePrice,
      marginBlocked: requiredMargin,
      sl: parseFloat(stopLossPrice) || (tradePrice * 0.98),
      target: parseFloat(targetPrice) || (tradePrice * 1.05),
      pnl: 0
    };

    setPositions(prev => [newPosition, ...prev]);
    setLedgerHistory(prev => [
      { id: Date.now(), type: 'TRADE EXECUTION', amount: -requiredMargin, desc: `Executed ${newPosition.type} ${orderQty}x ${tradeSymbol} @ ₹${tradePrice} (Margin Blocked)`, date: new Date().toLocaleDateString() },
      ...prev
    ]);
    closeOrderWindow();
    alert(`🚀 Paper Order Executed! Margin Blocked: ₹ ${requiredMargin.toFixed(2)}`);
  };

  // SQUARE OFF & REALIZED P&L SETTLEMENT
  const squareOffPosition = (posId) => {
    const targetPos = positions.find(p => p.id === posId);
    if (!targetPos) return;

    const settlementAmount = targetPos.marginBlocked + targetPos.pnl;
    setVirtualWallet(prev => prev + settlementAmount); // Return Margin + P&L
    setPositions(prev => prev.filter(p => p.id !== posId));
    
    setLedgerHistory(prev => [
      { id: Date.now(), type: 'SQUARE OFF', amount: settlementAmount, desc: `Closed position ${targetPos.symbol}. Realized P&L: ₹${targetPos.pnl.toFixed(2)}`, date: new Date().toLocaleDateString() },
      ...prev
    ]);
    alert(`✅ Successfully squared off ${targetPos.symbol}. Realized P&L: ₹${targetPos.pnl.toFixed(2)} settled in wallet.`);
  };

  // AUTOMATED STOP-LOSS & TARGET TRIGGER ENGINE (BACKGROUND DAEMON)
  useEffect(() => {
    if (currentView === 'dashboard') {
      const interval = setInterval(() => {
        let currentTotalPnL = 0;
        const remainingPositions = [];

        positions.forEach(pos => {
          const tick = (Math.random() * 20) - 10;
          const newLtp = Math.max(1, pos.ltp + tick);
          const pnlCalc = pos.type === 'BUY' || pos.type === 'CE' ? (newLtp - pos.avgPrice) * pos.qty : (pos.avgPrice - newLtp) * pos.qty;

          // Check if SL or Target triggered
          const isBuyType = pos.type === 'BUY' || pos.type === 'CE';
          const hitStopLoss = isBuyType ? newLtp <= pos.sl : newLtp >= pos.sl;
          const hitTarget = isBuyType ? newLtp >= pos.target : newLtp <= pos.target;

          if (hitStopLoss || hitTarget) {
            // Auto square off & settle margin + pnl
            const settlementAmount = pos.marginBlocked + pnlCalc;
            setVirtualWallet(wallet => wallet + settlementAmount);
            setTriggeredAlert(`⚡ AUTO-CLOSED ${pos.symbol}: ${hitStopLoss ? 'Stop-Loss Hit 🛑' : 'Target Achieved 🎯'} (P&L: ₹${pnlCalc.toFixed(2)})`);
            playAlertSound();
            setLedgerHistory(ledger => [
              { id: Date.now(), type: hitStopLoss ? 'AUTO SL HIT' : 'AUTO TARGET HIT', amount: settlementAmount, desc: `Automated close for ${pos.symbol} @ LTP ₹${newLtp.toFixed(2)} (P&L: ₹${pnlCalc.toFixed(2)})`, date: new Date().toLocaleDateString() },
              ...ledger
            ]);
          } else {
            let updatedSl = pos.sl;
            if (isTrailBotActive && newLtp > pos.avgPrice) {
              const potentialNewSl = +(newLtp - trailBuffer).toFixed(2);
              if (potentialNewSl > pos.sl) {
                updatedSl = potentialNewSl;
              }
            }
            currentTotalPnL += pnlCalc;
            remainingPositions.push({ ...pos, ltp: newLtp, sl: updatedSl, pnl: pnlCalc });
          }
        });

        setPositions(remainingPositions);
        setTotalPnL(currentTotalPnL);

        setSectorHeatmapData(prev => prev.map(sec => {
          const tick = (Math.random() * 0.4) - 0.2;
          const currentVal = parseFloat(sec.change);
          const newVal = +(currentVal + tick).toFixed(2);
          return { ...sec, change: (newVal >= 0 ? "+" : "") + newVal + "%", isUp: newVal >= 0 };
        }));

        setHoldings(prev => prev.map(item => {
          const tick = (Math.random() * 4) - 2;
          const newLtp = Math.max(1, item.ltp + tick);
          const pnlCalc = (newLtp - item.avgPrice) * item.qty;
          return { ...item, ltp: newLtp, pnl: pnlCalc };
        }));

        setMarketIndices(prev => prev.map(idx => {
          const changeTick = (Math.random() * 4) - 2;
          const newPrice = +(idx.price + changeTick).toFixed(2);
          const newChange = +(parseFloat(idx.change) + (changeTick * 0.1)).toFixed(2);
          const isUp = newChange >= 0;
          return { ...idx, price: newPrice, change: (isUp ? "+" : "") + newChange, percent: (isUp ? "+" : "") + (newChange / 100).toFixed(2) + "%", isUp: isUp };
        }));

        setLeaderboardData(prev => prev.map(item => item.name === "Aap (You)" ? { ...item, pnl: currentTotalPnL, score: disciplineScore } : item));

        if (alerts.length > 0 && Math.random() < 0.05) {
          const randomAlert = alerts[0];
          setTriggeredAlert(`🚨 PRICE ALERT TRIGGERED: ${randomAlert.symbol} reached target ₹ ${randomAlert.targetPrice}!`);
          playAlertSound();
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [currentView, positions, disciplineScore, alerts, isTrailBotActive, trailBuffer]);

  if (currentView === 'landing') return <LandingPage onGetStarted={() => setCurrentView('auth')} isDarkMode={isDarkMode} toggleTheme={toggleTheme} />;
  if (currentView === 'auth') return <Login onLoginSuccess={() => setCurrentView('dashboard')} isDarkMode={isDarkMode} toggleTheme={toggleTheme} />;

  return (
    <div className={`app-container ${isDarkMode ? '' : 'theme-light'}`}>
      
      <WelcomeModal isOpen={isWelcomeOpen} onClose={() => setIsWelcomeOpen(false)} />

      {triggeredAlert && (
        <div className="alert-popup-banner">
          <span>{triggeredAlert}</span>
          <button onClick={() => setTriggeredAlert(null)}>Dismiss</button>
        </div>
      )}

      {/* Global Index Ticker Bar */}
      <div className="global-index-ticker">
        <div className="market-mode-switcher">
          <button className={`mode-pill-btn ${marketMode === 'INDIAN' ? 'active-mode-indian' : ''}`} onClick={() => setMarketMode('INDIAN')}>🇮🇳 INDIAN MARKET</button>
          <button className={`mode-pill-btn ${marketMode === 'CRYPTO' ? 'active-mode-crypto' : ''}`} onClick={() => setMarketMode('CRYPTO')}>🪙 CRYPTO MARKET</button>
        </div>

        {(marketMode === 'INDIAN' ? marketIndices : cryptoIndices).map((idx, index) => (
          <div className="index-pill" key={index}>
            <span className="idx-name">{idx.symbol}</span>
            <span className="idx-price">{marketMode === 'INDIAN' ? '₹' : '$'} {idx.price.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
            <span className={idx.isUp ? "idx-change text-green" : "idx-change text-red"}>{idx.change} ({idx.percent})</span>
          </div>
        ))}
      </div>

      <header className="top-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/logo1.png" alt="Logo" style={{ height: '40px', width: 'auto', objectFit: 'contain' }} />
            </div>
        
        <div className="news-ticker-container">
          <div className="ticker-badge">AI SENTIMENT</div>
          <div className="ticker-scroll">
            {marketNews.map((news) => (
              <span key={news.id} className="ticker-item">{news.text} &nbsp; <strong style={{color: news.sentiment.includes('BULLISH') ? '#00C853' : '#FF1744'}}>{news.sentiment}</strong>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
            ))}
          </div>
        </div>

        <div className="header-right">
          <button className="theme-btn" onClick={toggleTheme}>{isDarkMode ? '☀️ Light' : '🌙 Dark'}</button>
          <button className="theme-btn" onClick={() => setIsReportModalOpen(true)} style={{backgroundColor: '#D4AF37', color: '#000', fontWeight: 'bold'}}>📄 PDF Report</button>
          
          <div className="virtual-margin" title={marketMode === 'INDIAN' ? `~$ {((virtualWallet + totalPnL) / 84).toLocaleString(undefined, {minimumFractionDigits: 2})} USD` : `~₹ {((virtualWallet + totalPnL) * 84).toLocaleString(undefined, {minimumFractionDigits: 2})} INR`}>
            <span>{marketMode === 'INDIAN' ? 'Wallet (INR): ' : 'Wallet (USD): '}</span>
            <span className="amount">
              {marketMode === 'INDIAN' ? '₹ ' : '$ '} 
              {(marketMode === 'INDIAN' ? (virtualWallet + totalPnL) : (virtualWallet + totalPnL) / 84).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
            </span>
          </div>
        </div>
      </header>

      <div className="terminal-layout">
        
        <aside className="watchlist-sidebar">
          <div className="search-bar">
            <input type="text" placeholder={marketMode === 'INDIAN' ? "Search Nifty, Sensex..." : "Search BTC, ETH, SOL..."} />
          </div>
          <div className="stock-list">
            {(marketMode === 'INDIAN' ? indianWatchList : cryptoWatchList).map((stock, index) => (
              <div className="stock-item" key={index}>
                <div className="stock-info"><h4>{stock.symbol}</h4></div>
                <div className="stock-price"><h4 className={stock.isUp ? "text-green" : "text-red"}>{stock.price}</h4></div>
              </div>
            ))}
          </div>
        </aside>

        <main className="workspace-area">
          
          <div className="workspace-tabs" style={{ display: 'flex', flexWrap: 'wrap', backgroundColor: 'var(--bg-panel-solid)', borderBottom: '1px solid var(--border-color)', padding: '10px 15px', alignItems: 'center', gap: '8px' }}>
            <button className={`tab-btn ${activeTab === 'chart' ? 'active-tab' : ''}`} onClick={() => setActiveTab('chart')}>📈 Chart</button>
            <button className={`tab-btn ${activeTab === 'analytics' ? 'active-tab' : ''}`} onClick={() => setActiveTab('analytics')}>📊 Analytics</button>
            <button className={`tab-btn ${activeTab === 'guardian' ? 'active-tab' : ''}`} onClick={() => setActiveTab('guardian')}>🛡️ Risk Guardian</button>
            <button className={`tab-btn ${activeTab === 'greeks' ? 'active-tab' : ''}`} onClick={() => setActiveTab('greeks')}>📈 Greeks</button>
            <button className={`tab-btn ${activeTab === 'builder' ? 'active-tab' : ''}`} onClick={() => setActiveTab('builder')}>📐 Strategy Builder</button>
            <button className={`tab-btn ${activeTab === 'algo' ? 'active-tab' : ''}`} onClick={() => setActiveTab('algo')}>⚡ Algo Bot</button>
            <button className={`tab-btn ${activeTab === 'heatmap' ? 'active-tab' : ''}`} onClick={() => setActiveTab('heatmap')}>🗺️ Heatmap</button>
            <button className={`tab-btn ${activeTab === 'optionchain' ? 'active-tab' : ''}`} onClick={() => setActiveTab('optionchain')}>📊 Option Chain</button>
            <button className={`tab-btn ${activeTab === 'pricing' ? 'active-tab' : ''}`} onClick={() => setActiveTab('pricing')}>💎 Plans & Pricing</button>
            <button className={`tab-btn ${activeTab === 'courses' ? 'active-tab' : ''}`} onClick={() => setActiveTab('courses')}>📚 Trading Courses</button>
            <button className={`tab-btn ${activeTab === 'basket' ? 'active-tab' : ''}`} onClick={() => setActiveTab('basket')}>📦 Basket</button>
            <button className={`tab-btn ${activeTab === 'autotrade' ? 'active-tab' : ''}`} onClick={() => setActiveTab('autotrade')}>⚡ Auto-Trade</button>
            <button className={`tab-btn ${activeTab === 'trailbot' ? 'active-tab' : ''}`} onClick={() => setActiveTab('trailbot')}>🤖 Trail Bot</button>
            <button className={`tab-btn ${activeTab === 'backtest' ? 'active-tab' : ''}`} onClick={() => setActiveTab('backtest')}>🧪 Backtest</button>
            <button className={`tab-btn ${activeTab === 'riskcalc' ? 'active-tab' : ''}`} onClick={() => setActiveTab('riskcalc')}>🧮 Risk Calc</button>
            <button className={`tab-btn ${activeTab === 'journal' ? 'active-tab' : ''}`} onClick={() => setActiveTab('journal')}>📓 Journal</button>
            <button className={`tab-btn ${activeTab === 'leaderboard' ? 'active-tab' : ''}`} onClick={() => setActiveTab('leaderboard')}>🏆 Leaderboard</button>
            <button className={`tab-btn ${activeTab === 'reportcard' ? 'active-tab' : ''}`} onClick={() => setActiveTab('reportcard')}>📋 Report Card</button>
            <button className={`tab-btn ${activeTab === 'holdings' ? 'active-tab' : ''}`} onClick={() => setActiveTab('holdings')}>📦 Holdings</button>
            <button className={`tab-btn ${activeTab === 'socialchat' ? 'active-tab' : ''}`} onClick={() => setActiveTab('socialchat')}>💬 Social</button>
            <button className={`tab-btn ${activeTab === 'aichat' ? 'active-tab' : ''}`} onClick={() => setActiveTab('aichat')}>🤖 AI Chat</button>
            <button className={`tab-btn ${activeTab === 'alerts' ? 'active-tab' : ''}`} onClick={() => setActiveTab('alerts')}>🔔 Alerts</button>
            <button className={`tab-btn ${activeTab === 'settings' ? 'active-tab' : ''}`} onClick={() => setActiveTab('settings')}>🔌 Broker</button>
            <button className={`tab-btn ${activeTab === 'funds' ? 'active-tab' : ''}`} onClick={() => setActiveTab('funds')}>💰 Funds</button>
          </div>

          <div className="chart-and-actions">
            
            <div className="chart-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 1, minHeight: '450px' }}>
              {activeTab === 'chart' && (
                <div className="chart-with-timeframes" style={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 1 }}>
                  <div className="timeframe-bar">
                    <span className="tf-label">Timeframe:</span>
                    {timeframes.map((tf) => (
                      <button key={tf} className={`tf-btn ${selectedTimeframe === tf ? 'active-tf' : ''}`} onClick={() => setSelectedTimeframe(tf)}>{tf}</button>
                    ))}
                  </div>
                  <div className="live-chart-box" style={{ flex: 1, width: '100%', minHeight: '400px', position: 'relative' }}>
                    <AdvancedRealTimeChart 
                      theme={isDarkMode ? "dark" : "light"} 
                      symbol={marketMode === 'INDIAN' ? "BSE:SENSEX" : "BINANCE:BTCUSDT"} 
                      interval={selectedTimeframe === '1S' ? '1' : selectedTimeframe === '1M' ? '1' : selectedTimeframe === '4H' ? '240' : 'D'}
                      autosize 
                    />
                  </div>
                </div>
              )}

              {activeTab === 'analytics' && <AdvancedAnalytics positions={positions} totalPnL={totalPnL} tradeCount={tradeCount} disciplineScore={disciplineScore} />}
              {activeTab === 'guardian' && <RiskGuardian positions={positions} totalPnL={totalPnL} virtualWallet={virtualWallet} disciplineScore={disciplineScore} />}
              {activeTab === 'greeks' && <OptionsGreeks />}
              {activeTab === 'builder' && <StrategyBuilder />}
              {activeTab === 'algo' && <AlgoTradingBot />}
              {activeTab === 'optionchain' && <OptionChain />}
              {activeTab === 'backtest' && <StrategyBacktester />}

              {activeTab === 'pricing' && (
                <div style={{ padding: '30px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)' }}>
                  <div style={{ marginBottom: '25px', textAlign: 'center' }}>
                    <h2 style={{ color: 'var(--vyodha-gold)', fontSize: '26px', marginBottom: '8px' }}>💎 Upgrade Your Trading Terminal</h2>
                    <p style={{ color: 'var(--text-muted)', fontSize: '13px' }}>Unlock live API execution, advanced AI scans, and lifetime mentorship.</p>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', maxWidth: '900px', margin: '0 auto' }}>
                    <div style={{ backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', borderRadius: '12px', padding: '25px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <div>
                        <h3 style={{ color: 'var(--vyodha-gold)', fontSize: '18px', marginBottom: '10px' }}>Pro Monthly</h3>
                        <div style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '15px' }}>₹ 999 <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>/ month</span></div>
                      </div>
                      <button onClick={() => alert("Payment Successful!")} style={{ backgroundColor: 'var(--vyodha-gold)', color: '#000', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', marginTop: '20px' }}>
                        Pay via Gateway
                      </button>
                    </div>

                    <div style={{ backgroundColor: 'var(--bg-panel)', border: '1px solid #D4AF37', borderRadius: '12px', padding: '25px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <div>
                        <span style={{ backgroundColor: 'rgba(212,175,55,0.2)', color: '#D4AF37', padding: '3px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold' }}>POPULAR</span>
                        <h3 style={{ color: 'var(--vyodha-gold)', fontSize: '18px', marginTop: '8px', marginBottom: '10px' }}>Quarterly Elite</h3>
                        <div style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '15px' }}>₹ 2,999</div>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '20px' }}>
                        <button onClick={() => alert("Payment Successful!")} style={{ backgroundColor: 'var(--vyodha-gold)', color: '#000', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
                          Pay via Gateway
                        </button>
                        <button onClick={() => {
                          if ((currentUser.points || 0) >= 2000) {
                            setCurrentUser(prev => ({ ...prev, points: prev.points - 2000 }));
                            alert("🎉 Success! 2000 points redeemed.");
                          } else {
                            alert("⚠️ Insufficient points! Need 2000 PTS.");
                          }
                        }} style={{ backgroundColor: 'transparent', color: '#00C853', border: '1px solid #00C853', padding: '10px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>
                          Redeem 2000 Points (Free)
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'courses' && (
                <div style={{ padding: '30px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)', color: 'var(--text-main)' }}>
                  <h2 style={{ color: 'var(--vyodha-gold)', fontSize: '24px', marginBottom: '15px' }}>📚 Elite Institutional Trading Courses</h2>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px' }}>
                    <div style={{ backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', borderRadius: '10px', padding: '20px' }}>
                      <h3 style={{ color: 'var(--text-main)', fontSize: '16px', marginBottom: '8px' }}>Advanced Options Greeks & Hedging</h3>
                      <p style={{ color: 'var(--text-muted)', fontSize: '12px', marginBottom: '15px' }}>Master Delta neutrality and Theta decay.</p>
                      <button onClick={() => alert("Course Unlocked!")} style={{ backgroundColor: '#00C853', color: '#fff', border: 'none', padding: '10px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', width: '100%' }}>Enroll Now</button>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'basket' && (
                <div className="basket-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <div className="basket-header" style={{marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px'}}>📦 Multi-Leg Basket Orders</h2>
                    <button onClick={executeBasketOrder} className="btn-primary" style={{backgroundColor: '#00C853', color: '#fff', fontSize: '14px', padding: '12px 24px'}}>🚀 Execute Basket Now</button>
                  </div>
                  <table className="positions-table">
                    <thead><tr><th>Symbol</th><th>Action</th><th>Qty</th><th>Price</th></tr></thead>
                    <tbody>
                      {basketItems.map(item => (
                        <tr key={item.id}><td>{item.symbol}</td><td className={item.action === 'BUY' ? 'text-green' : 'text-red'}>{item.action}</td><td>{item.qty}</td><td>₹ {item.price}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'autotrade' && (
                <div className="autotrade-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>⚡ AI Auto-Trade Rules</h2>
                  <div style={{backgroundColor: 'var(--bg-panel)', padding: '20px', borderRadius: '10px', border: '1px solid var(--border-color)'}}>
                    <p style={{fontSize: '13px', color: 'var(--text-muted)'}}>Active Rules: RSI (14) Crosses Below 30 -> Buy Nifty 50</p>
                  </div>
                </div>
              )}

              {activeTab === 'heatmap' && (
                <div className="heatmap-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🗺️ Live Market Sector Heatmap</h2>
                  <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px'}}>
                    {sectorHeatmapData.map((sec, idx) => (
                      <div key={idx} style={{backgroundColor: sec.isUp ? 'rgba(0,200,83,0.1)' : 'rgba(255,23,68,0.1)', padding: '15px', borderRadius: '8px', border: `1px solid ${sec.isUp ? '#00C853' : '#FF1744'}`}}>
                        <strong>{sec.sector}</strong>
                        <div style={{fontSize: '16px', fontWeight: 'bold', color: sec.isUp ? '#00C853' : '#FF1744', marginTop: '5px'}}>{sec.change}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'holdings' && (
                <div className="holdings-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>📦 Long-Term Investment Portfolio</h2>
                  <table className="positions-table">
                    <thead><tr><th>Asset</th><th>Qty</th><th>Avg Price</th><th>LTP</th><th>P&L</th></tr></thead>
                    <tbody>
                      {holdings.map(h => (
                        <tr key={h.id}><td>{h.symbol}</td><td>{h.qty}</td><td>₹ {h.avgPrice}</td><td>₹ {h.ltp}</td><td className={h.pnl >= 0 ? 'text-green' : 'text-red'}>₹ {h.pnl.toFixed(2)}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'journal' && (
                <div className="journal-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>📓 AI Trade Journal</h2>
                  <form onSubmit={handleAddJournal} style={{display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '500px'}}>
                    <select value={selectedEmotion} onChange={(e) => setSelectedEmotion(e.target.value)} style={{padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}}>
                      <option value="Calm & Planned">Calm & Planned</option>
                      <option value="FOMO (Fear of Missing Out)">FOMO</option>
                      <option value="Revenge Trading">Revenge Trading</option>
                    </select>
                    <textarea placeholder="Write trade notes..." value={journalNote} onChange={(e) => setJournalNote(e.target.value)} rows="3" style={{padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <button type="submit" className="btn-primary">Save & Analyze</button>
                  </form>
                </div>
              )}

              {activeTab === 'riskcalc' && (
                <div className="riskcalc-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🧮 AI Risk & Position Sizing Calculator</h2>
                  <form onSubmit={calculateRiskPosition} style={{display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '400px'}}>
                    <input type="number" placeholder="Capital" value={calcCapital} onChange={(e) => setCalcCapital(e.target.value)} style={{padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <button type="submit" className="btn-primary">Calculate Position</button>
                  </form>
                  {calcResult && (
                    <div style={{marginTop: '15px', padding: '15px', background: 'var(--bg-panel)', borderRadius: '8px', border: '1px solid var(--border-color)'}}>
                      <p>Recommended Qty: <strong>{calcResult.recommendedQty}</strong></p>
                      <p>{calcResult.aiVerdict}</p>
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'trailbot' && (
                <div className="trailbot-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🤖 AI Automated Trailing Stop-Loss Bot</h2>
                  <button onClick={() => setIsTrailBotActive(!isTrailBotActive)} style={{backgroundColor: isTrailBotActive ? '#FF1744' : '#00C853', color: '#fff', padding: '12px 24px', borderRadius: '8px', border: 'none', fontWeight: 'bold', cursor: 'pointer'}}>
                    {isTrailBotActive ? 'STOP TRAILING BOT' : 'START TRAILING BOT'}
                  </button>
                </div>
              )}

              {activeTab === 'socialchat' && (
                <div className="socialchat-container" style={{padding: '20px', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '20px', marginBottom: '10px'}}>💬 Social Trading Room</h2>
                  <div style={{flex: 1, backgroundColor: 'var(--bg-panel)', padding: '15px', borderRadius: '8px', overflowY: 'auto', marginBottom: '10px'}}>
                    {chatRoomMessages.map((msg) => (
                      <div key={msg.id} style={{marginBottom: '10px'}}><strong>{msg.sender}:</strong> {msg.text}</div>
                    ))}
                  </div>
                  <form onSubmit={handleSendSocialMessage} style={{display: 'flex', gap: '8px'}}>
                    <input type="text" placeholder="Type message..." value={socialMessageInput} onChange={(e) => setSocialMessageInput(e.target.value)} style={{flex: 1, padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <button type="submit" className="btn-primary" style={{margin: 0}}>Send</button>
                  </form>
                </div>
              )}

              {activeTab === 'aichat' && (
                <div className="aichat-container" style={{padding: '20px', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'var(--bg-main)'}}>
                  <div className="aichat-header" style={{marginBottom: '10px'}}>
                    <h2 style={{color: 'var(--vyodha-gold)', fontSize: '20px', marginBottom: '3px'}}>🤖 Vyodha AI Assistant & Gemini Chat</h2>
                    <p style={{color: 'var(--text-muted)', fontSize: '12px'}}>Chat live with real Google Gemini AI or upload a chart screenshot for institutional insights.</p>
                  </div>

                  <div className="chat-messages-box" style={{flex: 1, backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '15px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '12px', maxHeight: '360px'}}>
                    {chatMessages.map((msg, index) => (
                      <div key={index} style={{alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start', maxWidth: '85%', backgroundColor: msg.sender === 'user' ? '#138808' : 'var(--bg-main)', color: '#ffffff', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--border-color)'}}>
                        {msg.image && <img src={msg.image} alt="Chart upload" style={{maxWidth: '100%', borderRadius: '6px', marginBottom: '6px'}} />}
                        <p style={{whiteSpace: 'pre-line', fontSize: '13px', margin: 0}}>{msg.text}</p>
                      </div>
                    ))}
                    {isAiTyping && (
                      <div style={{alignSelf: 'flex-start', color: 'var(--vyodha-gold)', fontStyle: 'italic', fontSize: '12px'}}>
                        🤖 Gemini is generating live response...
                      </div>
                    )}
                  </div>

                  {uploadedImagePreview && (
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px', backgroundColor: 'var(--bg-panel)', padding: '6px 10px', borderRadius: '6px', border: '1px solid var(--border-color)'}}>
                      <img src={uploadedImagePreview} alt="preview" style={{width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px'}} />
                      <span style={{fontSize: '12px', color: 'var(--text-main)'}}>Image attached ready to send</span>
                      <button onClick={() => setUploadedImagePreview(null)} style={{marginLeft: 'auto', background: 'none', border: 'none', color: '#FF1744', cursor: 'pointer', fontWeight: 'bold'}}>Remove</button>
                    </div>
                  )}

                  <form onSubmit={handleSendMessage} style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                    <label style={{cursor: 'pointer', backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', padding: '10px 12px', borderRadius: '6px', color: 'var(--text-main)', fontSize: '14px'}} title="Upload Chart Screenshot">
                      📷
                      <input type="file" accept="image/*" onChange={handleImageSelect} style={{display: 'none'}} />
                    </label>
                    <input 
                      type="text" 
                      placeholder="Ask Gemini anything about trading, options, or market analysis..." 
                      value={inputMessage}
                      onChange={(e) => setInputMessage(e.target.value)}
                      style={{flex: 1, backgroundColor: 'var(--bg-panel)', border: '1px solid var(--border-color)', color: 'var(--text-main)', padding: '10px 14px', borderRadius: '6px', fontSize: '13px', outline: 'none'}}
                    />
                    <button type="submit" className="btn-primary" style={{padding: '10px 18px', margin: 0}}>Send</button>
                  </form>
                </div>
              )}

              {activeTab === 'settings' && (
                <div className="settings-container" style={{padding: '30px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🔌 Multi-Broker API Integration</h2>
                  <form onSubmit={handleConnectApi} style={{display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '400px'}}>
                    <select value={selectedBroker} onChange={(e) => setSelectedBroker(e.target.value)} style={{padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}}>
                      <option value="Zerodha Kite">Zerodha Kite</option>
                      <option value="Upstox API">Upstox</option>
                      <option value="Binance">Binance</option>
                    </select>
                    <input type="text" placeholder="API Key" value={apiKeyInput} onChange={(e) => setApiKeyInput(e.target.value)} style={{padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <input type="password" placeholder="API Secret" value={apiSecretInput} onChange={(e) => setApiSecretInput(e.target.value)} style={{padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <button type="submit" className="btn-primary">Connect Broker</button>
                  </form>
                </div>
              )}

              {activeTab === 'alerts' && (
                <div className="alerts-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🔔 Advanced Price Alert System</h2>
                  <form onSubmit={handleAddAlert} style={{display: 'flex', gap: '10px', maxWidth: '500px'}}>
                    <input type="number" placeholder="Target Price" value={alertPrice} onChange={(e) => setAlertPrice(e.target.value)} style={{flex: 1, padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <button type="submit" className="btn-primary" style={{margin: 0}}>Set Alert</button>
                  </form>
                </div>
              )}

              {activeTab === 'funds' && (
                <div className="funds-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>Virtual Margin & Wallet Management</h2>
                  <div style={{fontSize: '24px', fontWeight: 'bold', color: '#00C853', marginBottom: '20px'}}>
                    Available Margin: {marketMode === 'INDIAN' ? '₹ ' : '$ '} 
                    {(marketMode === 'INDIAN' ? virtualWallet : virtualWallet / 84).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                  </div>
                  <form onSubmit={handleAddFunds} style={{display: 'flex', gap: '10px', maxWidth: '400px'}}>
                    <input type="number" placeholder="Deposit Amount" value={depositAmount} onChange={(e) => setDepositAmount(e.target.value)} style={{flex: 1, padding: '10px', background: 'var(--bg-panel)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '6px'}} />
                    <button type="submit" className="btn-primary" style={{margin: 0}}>Deposit</button>
                  </form>
                </div>
              )}

              {activeTab === 'leaderboard' && (
                <div className="leaderboard-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🏆 Vyodha Traders Leaderboard</h2>
                  <table className="positions-table">
                    <thead><tr><th>Rank</th><th>Name</th><th>Badge</th><th>Score</th><th>P&L</th></tr></thead>
                    <tbody>
                      {leaderboardData.map((t, idx) => (
                        <tr key={idx}><td>#{idx+1}</td><td>{t.name}</td><td>{t.badge}</td><td>{t.score}</td><td className={t.pnl >= 0 ? 'text-green' : 'text-red'}>₹ {t.pnl}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'reportcard' && (
                <div className="report-card-container" style={{padding: '25px', height: '100%', overflowY: 'auto', backgroundColor: 'var(--bg-main)'}}>
                  <h2 style={{color: 'var(--vyodha-gold)', fontSize: '22px', marginBottom: '15px'}}>🧠 AI Post-Market Psychology Report</h2>
                  <div style={{background: 'var(--bg-panel)', padding: '20px', borderRadius: '10px', border: '1px solid var(--border-color)'}}>
                    <p>Discipline Score: <strong>{disciplineScore} / 100</strong></p>
                    <p>Total Trades: <strong>{tradeCount}</strong></p>
                  </div>
                </div>
              )}

            </div>
            
            {/* AI Sidebar */}
            <aside className="ai-sidebar">
              <div className="ai-header">
                <h3>🤖 Vyodha AI</h3>
                <span className="live-dot"></span>
              </div>
              <div className="score-section">
                <p className="score-title">Discipline Score</p>
                <div className={`score-circle ${disciplineScore > 75 ? 'score-green' : 'score-orange'}`}>{disciplineScore}</div>
                <p className="trade-count">Trades: <strong>{tradeCount}</strong></p>
              </div>

              <div style={{ backgroundColor: 'var(--bg-panel)', border: '1px solid #D4AF37', padding: '12px', borderRadius: '8px', marginTop: '10px' }}>
                <h4 style={{ color: '#D4AF37', fontSize: '12px', margin: '0 0 4px 0' }}>🎁 Refer & Earn Rewards</h4>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'var(--bg-main)', padding: '6px 8px', borderRadius: '6px', border: '1px solid var(--border-color)', margin: '8px 0' }}>
                  <strong style={{ color: '#00C853', fontSize: '12px' }}>{currentUser.myReferralCode}</strong>
                  <button onClick={() => { navigator.clipboard.writeText(currentUser.myReferralCode); alert("Copied!"); }} style={{ backgroundColor: '#D4AF37', color: '#000', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', cursor: 'pointer' }}>Copy</button>
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-main)' }}>Points: <strong style={{ color: '#D4AF37' }}>{currentUser.points || 0} PTS</strong></div>
              </div>

              <div className="sidebar-order-panel">
                <div className="quick-symbol-tag">
                  <span>Asset:</span> 
                  <strong>{selectedOption ? `${selectedOption.strike} ${selectedOption.type}` : (marketMode === 'INDIAN' ? "SENSEX" : "BTC/USDT")}</strong>
                </div>
                <div className="sidebar-action-btns">
                  <button className="btn-buy-pro" onClick={() => openOrderWindow('BUY')}>
                    <span className="btn-icon">📈</span>
                    <div className="btn-text"><small>FAST BUY</small><strong>BUY</strong></div>
                  </button>
                  <button className="btn-sell-pro" onClick={() => openOrderWindow('SELL')}>
                    <span className="btn-icon">📉</span>
                    <div className="btn-text"><small>FAST SELL</small><strong>SELL</strong></div>
                  </button>
                </div>
              </div>
            </aside>
          </div>

          {/* Positions Panel */}
          <div className="positions-panel">
            <div className="positions-header">
              <h3>Live Positions & Risk Management</h3>
              <h3 className={totalPnL >= 0 ? 'text-green' : 'text-red'}>Total P&L: ₹ {totalPnL.toFixed(2)}</h3>
            </div>
            <div className="positions-table">
              <table>
                <thead>
                  <tr><th>Symbol</th><th>Type</th><th>Qty</th><th>Avg Price</th><th>Stop-Loss</th><th>Target</th><th>LTP</th><th>P&L</th><th>Action</th></tr>
                </thead>
                <tbody>
                  {positions.length === 0 ? (
                    <tr><td colSpan="9" style={{textAlign:'center', padding:'20px', color:'#666'}}>No active positions. Execute an order with SL/Target.</td></tr>
                  ) : (
                    positions.map((pos) => (
                      <tr key={pos.id}>
                        <td style={{fontWeight:'bold'}}>{pos.symbol}</td>
                        <td className={pos.type === 'BUY' || pos.type === 'CE' ? 'text-green' : 'text-red'}>{pos.type}</td>
                        <td>{pos.qty}</td>
                        <td>₹ {pos.avgPrice.toFixed(2)}</td>
                        <td className="text-red">₹ {pos.sl} 🛑</td>
                        <td className="text-green">₹ {pos.target} 🎯</td>
                        <td>₹ {pos.ltp.toFixed(2)}</td>
                        <td className={pos.pnl >= 0 ? 'text-green' : 'text-red'} style={{fontWeight:'bold'}}>{pos.pnl >= 0 ? '+' : '-'} ₹ {Math.abs(pos.pnl).toFixed(2)}</td>
                        <td>
                          <button onClick={() => squareOffPosition(pos.id)} style={{backgroundColor: '#EF4444', color: '#FFF', border: 'none', padding: '4px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold'}}>Square Off</button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </main>

      </div>

      <PerformanceReportModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} metrics={{ totalPnL, disciplineScore, tradeCount }} />

      {orderType && (
        <div className="modal-overlay">
          <div className={`order-modal ${orderType === 'BUY' ? 'buy-theme' : 'sell-theme'}`}>
            <div className="modal-header">
              <h3>{selectedOption ? `${selectedOption.strike} ${selectedOption.type}` : `${orderType} ${marketMode === 'INDIAN' ? 'SENSEX' : 'BTC/USDT'}`}</h3>
              <button className="close-btn" style={{background: 'none', border: 'none', color:'white', fontSize:'18px', cursor:'pointer'}} onClick={closeOrderWindow}>X</button>
            </div>
            <div className="modal-body">
              <div className="input-group"><label>Qty / Lot Size</label><input type="number" defaultValue={marketMode === 'INDIAN' ? "50" : "1"} /></div>
              <div className="input-group"><label>Execution Price</label><input type="number" defaultValue={selectedOption ? selectedOption.price : (marketMode === 'INDIAN' ? 80500.00 : 68450.00)} /></div>
              <div className="input-group"><label style={{color: '#FF1744'}}>Stop-Loss (SL)</label><input type="number" value={stopLossPrice} onChange={(e) => setStopLossPrice(e.target.value)} /></div>
              <div className="input-group"><label style={{color: '#00C853'}}>Target Price</label><input type="number" value={targetPrice} onChange={(e) => setTargetPrice(e.target.value)} /></div>
            </div>
            <div className="modal-footer">
               <button className={`submit-btn ${orderType === 'BUY' ? 'btn-buy' : 'btn-sell'}`} onClick={executeOrder}>EXECUTE PAPER TRADE</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;